import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SendIcon from "@mui/icons-material/Send";
import { Button, CircularProgress, IconButton, InputAdornment, TextField, } from "@mui/material";
import React, { useRef } from "react";
import AddMessageAttachmentDialog from "./AddMessageAttachmentDialog";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { FileUploader } from "./FileUploader";
const MessageTypeBar = (props) => {
    const [messageBody, setMessageBody] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const fileInputRef = useRef(null);
    const handleFileButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const handleFileUpload = (event) => {
        setLoading(true);
        FileUploader.handleUpload(event, async (file, base64) => {
            props.handleFileUpload(file, base64);
        });
        setLoading(false);
    };
    function handleInputChange(event) {
        setMessageBody(event.currentTarget.value);
    }
    function handleSubmit() {
        props.handleSubmit(messageBody);
        setMessageBody("");
    }
    function handleKeyPress(event) {
        if (event.key === "Enter") {
            handleSubmit();
        }
    }
    return (_jsx(TextField, { className: "typeMessageField", onChange: handleInputChange, value: messageBody, placeholder: "Type something here", onKeyPress: handleKeyPress, InputProps: {
            startAdornment: (_jsx(InputAdornment, { position: "start", children: false && _jsx(AddMessageAttachmentDialog, {}) })),
            endAdornment: (_jsxs(InputAdornment, { position: "end", children: [_jsx("input", { id: "File", name: "File", type: "file", style: { display: "none" }, ref: fileInputRef, onChange: (event) => {
                            handleFileUpload(event);
                        }, className: "form-control file-upload-input" }), loading ? (_jsx(CircularProgress, { sx: { mr: 1 }, color: "inherit" })) : (_jsx("div", { children: _jsx(IconButton, { edge: "start", className: "add-attachment", sx: { mr: 1 }, onClick: handleFileButtonClick, children: _jsx(AttachFileIcon, {}) }) })), _jsxs(Button, { variant: "contained", disableElevation: true, size: "small", onClick: handleSubmit, sx: { px: 1, py: 2 }, disabled: loading || props.error, children: [_jsx(SendIcon, { sx: { paddingRight: "5px" } }), "Send"] })] })),
        }, sx: {
            "& legend": { display: "none" },
            "& fieldset": { top: 0, border: "none" },
            "& hover fieldset": { borderColor: "grey" },
            "& focus fieldset": { borderColor: "grey" },
            boxShadow: 2,
        } }));
};
export default MessageTypeBar;
